import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

/**
 * The page shell, the same shape as the therapist's other page.
 *
 * Duplicated from `therapistIncome.styles.ts` rather than shared, which is the convention in
 * this tree: every feature owns its own page chrome. What is genuinely shared here is the
 * seven-row editor, and it lives in `components/program/` with its own styles.
 */

export const headerBoxStyles: SxProps<Theme> = {
    mb: 3,
};

export const titleStyles: SxProps<Theme> = {
    fontWeight: 700,
    letterSpacing: '-0.015em',
};

export const subtitleStyles: SxProps<Theme> = {
    color: 'text.secondary',
};

export const cardStyles: SxProps<Theme> = {
    p: 3,
    mb: 3,
};

/**
 * The line that says which of the two states this is: the clinic's hours, or your own.
 * Above the rows rather than beside the Save, because it is what the rows *mean* rather than
 * a warning about pressing anything.
 */
export const statusAlertStyles: SxProps<Theme> = {
    mb: 2.5,
};

export const alertStyles: SxProps<Theme> = {
    mb: 3,
};

export const loadingBoxStyles: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'center',
    py: 6,
};

/**
 * Save on the right, "use the clinic's hours" on the left and quiet -- it is the way back
 * rather than a second thing to decide.
 */
export const actionsStyles: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    flexWrap: 'wrap',
};

export const spacerStyles: SxProps<Theme> = {
    flexGrow: 1,
};

/**
 * The line beside a disabled Save that says why it is disabled. Modelled on the
 * count-of-problems hint the other editors already show.
 */
export const blockedSaveStyles: SxProps<Theme> = {
    color: 'error.main',
    alignSelf: 'center',
};
